export const textSkeletonStylesBlock1 = [
	{
		key: 'rect1',
		small: 'w-[83px]',
		medium: 'w-[164px]',
		large: 'w-[193px]',
	},
	{
		key: 'rect2',
		small: 'w-[91px]',
		medium: 'w-[179px]',
		large: 'w-[211px]',
	},
];

export const textSkeletonStylesBlock2 = [
	{
		key: 'rect-3',
		small: 'w-[75px]',
		medium: 'w-[154px]',
		large: 'w-[182px]',
	},
	{
		key: 'rect-4',
		small: 'w-[83px]',
		medium: 'w-[164px]',
		large: 'w-[193px]',
	},
	{
		key: 'rect-5',
		small: 'w-[91px]',
		medium: 'w-[179px]',
		large: 'w-[211px]',
	},
	{
		key: 'rect-6',
		small: 'w-[64px]',
		medium: 'w-[144px]',
		large: 'w-[170px]',
	},
	{
		key: 'rect-7',
		small: 'w-[86px]',
		medium: 'w-[171px]',
		large: 'w-[201px]',
	},
];

export const rectangleHeights = {
	small: 'h-[5px]',
	medium: 'h-2.5',
	large: 'h-[11px]',
};
